module.exports = __webpack_public_path__ + "static/mtb-15-98e1441799a4e25dba1df5c587bed219.jpg";